import React, { useState, useEffect } from 'react';

const themes = {
    light: {
        foreground: "#000000",
        background: "#ffffff",
        borderColor: "rgb(245, 242, 242)",
        boxShadow: "1px 1px 10px rgba(185, 185, 219, 0.5)",
        type: "light",
    },
    dark: {
        foreground: "#ffffff",
        background: "#1C2833",
        borderColor: "rgb(37, 37, 37)",
        boxShadow: "1px 1px 10px rgba(68, 67, 73, 0.5)",
        type: "dark",
    }
};

const ThemeContext = React.createContext();

export const ThemeContextProvider = (props) =>{
    const [currentTheme, setCurrentTheme] = useState({...themes.light});

    useEffect(()=>{ 
        const savedTheme = localStorage.getItem('site-theme');
        if (savedTheme === 'dark') {
            setCurrentTheme({...themes.dark});
        }
    }, []);
    
    const ThemeChangeHandler = () => {
        if (currentTheme.type === "light"){
            localStorage.setItem('site-theme', 'dark');
            setCurrentTheme({...themes.dark});
        }
        else{
            localStorage.removeItem('site-theme');
            setCurrentTheme({...themes.light});
        }

    }

    return (<ThemeContext.Provider value={{currentTheme: currentTheme, onThemeChange:ThemeChangeHandler}}>
        {props.children}
    </ThemeContext.Provider>)
}

export default ThemeContext;